import { Product, SelectedProduct } from "~/common/Store/models/ProductListing";

// eslint-disable-next-line import/prefer-default-export
export const getShowFromPricing = (
  product: Product,
  selectedProduct: SelectedProduct,
  userHasSelectedGroupMember?: boolean
) => {
  const priceIsTheSame = (groupingPrice: number, i: number, array: number[]) =>
    groupingPrice === array[0];

  let showFrom = false;

  if (product && selectedProduct) {
    const { groupMembers } = product.groupingAttributes;
    const groupingPrices = groupMembers.map(
      (groupMember) => groupMember.price.price
    );

    if (
      !groupingPrices.every(priceIsTheSame) &&
      groupMembers.length > 1 &&
      !userHasSelectedGroupMember
    ) {
      showFrom = true;
    }
  }

  return showFrom;
};
